import { Properties } from "@/services/posts/types";
import { CSS } from "@/services/styles/types";

export interface ClockPostProperties extends Properties {
    format: string;
    clockFormat: MomentFormat;
    timeZone: string;
    hourFormat: HourFormatEnum
    showTime: number;
}

export enum HourFormatEnum {
    h12 = "12hoursystem",
    h24 = "24hoursystem"
}

export interface Format {
    text: string;
    value: string;
}

export interface ClockCss extends CSS {
    clock: string;
}

export interface MomentFormat {
    textOne: string;
    textTwo: string;
    textThree: string;
    textFour: string;
    textFive: string;
    clockOptionOne: string;
    clockOptionTwo: string;
    clockOptionThree: string;
    clockOptionFour: string;
}

export const FormatOptions = [
    {
        text: "none",
        value: ""
    },
    {
        text: "h",
        value: "h"
    },
    {
        text: "hh",
        value: "hh"
    },
    {
        text: "m",
        value: "m"
    },
    {
        text: "mm",
        value: "mm"
    },
    {
        text: "s",
        value: "s"
    },
    {
        text: "ss",
        value: "ss"
    },
    {
        text: "ampm",
        value: "a"
    }
] as Array<Format>;

// date format
export const ClockFormats = [
    {
        text: "custom",
        value: "custom"
    },
    {
        text: "englishBritish",
        value: "e-b"
    },
    {
        text: "englishUS",
        value: "e-us"
    },
    {
        text: "danish",
        value: "dk"
    },
    {
        text: "swedish",
        value: "swed"
    },
    {
        text: "norweigan",
        value: "nor"
    },
    {
        text: "german",
        value: "ger"
    },
    {
        text: "french",
        value: "fr"
    }
];
